import { Tooltip } from '@dixa/lib-shared-habla';
import { useHasAccess } from 'lib-shared-access-control';
import { FullPresenceT, UserPresence } from 'lib-shared-legacy-types';

import { WorkloadLimits } from 'apis/presence';
import { useFeatureFlag } from 'utils/featureFlagging/useFeatureFlag';

import { PresencePopover } from '../presencePopover';
import { TeamChannelIcon } from '../teamChannelIcon';
import { getConversationGroups } from '../utils';

import styles from './teamChannelIconsList.module.scss';

type PropsT = {
  fullPresence?: FullPresenceT;
  limits: WorkloadLimits;
  isSimultaneousRingingActive: boolean;
} & Pick<UserPresence, 'workloads_by_channel'>;

export const TeamChannelIconsList: React.FC<PropsT> = ({
  workloads_by_channel: workloads,
  fullPresence,
  limits,
  isSimultaneousRingingActive,
}) => {
  const flags = useFeatureFlag(['presence-controls']);
  const hasPresenceAccess = useHasAccess(
    [
      'organization.member.presence.status',
      'organization.member.presence.working_media',
    ],
    { strategy: 'any' },
  );

  const conversationGroups = getConversationGroups(
    workloads,
    limits,
    fullPresence,
  );

  return (
    <>
      {conversationGroups.map(
        ({ id, icon, conversationCount, active, channels, tooltipContent }) =>
          channels.length > 0 && (
            <Tooltip
              key={id}
              wrapProps={{ className: styles.tooltipWrapper }}
              content={tooltipContent}
            >
              <TeamChannelIcon
                icon={icon}
                numberOfConversations={conversationCount}
                active={active}
              />
            </Tooltip>
          ),
      )}
      <TeamChannelIcon
        icon="simultaneous"
        active={isSimultaneousRingingActive}
      />
      {flags.presenceControls && hasPresenceAccess && fullPresence && (
        <PresencePopover fullPresence={fullPresence} />
      )}
    </>
  );
};
